'use client';

import { createContext, type RefObject } from 'react';
import { useStrictContext } from '../../lib/internal/hooks';
import type { PagePayload } from '../../Shibuya';

export interface AnalyticsPageViewContextValue {
  pageName: string;
  pageViewId: string;
  pageViewReady: boolean;
  pageUrlRef: RefObject<string>;
  contentId?: PagePayload['content_id'];
  contentSource?: PagePayload['content_source'];
}

export const AnalyticsPageViewContext = createContext<AnalyticsPageViewContextValue | null>(null);

export function useAnalyticsPageView() {
  return useStrictContext(AnalyticsPageViewContext);
}
